import { render, staticRenderFns } from "./k2Pdf.vue?vue&type=template&id=34c5ee3a"
import script from "./k2Pdf.vue?vue&type=script&lang=js"
export * from "./k2Pdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports